module.exports = __webpack_public_path__ + "img/welcome_user.b9aff107.svg";